import { render, staticRenderFns } from "./CoursesCatalog.vue?vue&type=template&id=117c4feb&scoped=true&"
import script from "./CoursesCatalog.vue?vue&type=script&lang=js&"
export * from "./CoursesCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CoursesCatalog.vue?vue&type=style&index=0&id=117c4feb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c4feb",
  null
  
)

component.options.__file = "CoursesCatalog.vue"
export default component.exports